// extracted by mini-css-extract-plugin
export var announcement = "announcements-module--announcement--ed5a5";
export var bold = "announcements-module--bold--85bcd";
export var button = "announcements-module--button--6e560";
export var container = "announcements-module--container--492c0";
export var image = "announcements-module--image--f8cbf";
export var list = "announcements-module--list--4595c";
export var serviceHeading = "announcements-module--serviceHeading--8dcac";
export var serviceSubHeading = "announcements-module--serviceSubHeading--8b0cd";
export var text = "announcements-module--text--3745d";